import React from 'react';

import { ListingsTemplate } from '../templates';
import { ListingListProvider } from '../useListingList';

export function NetworkPage() {
  return (
    <ListingListProvider key="network">
      <ListingsTemplate />
    </ListingListProvider>
  );
}
